import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent, EmailLayoutComponent } from './containers';
import { P404Component } from './views/components/error/404.component';
import { P500Component } from './views/components/error/500.component';
import { LoginComponent } from './views/components/login/login.component';
import { RegisterComponent } from './views/components/register/register.component';
import { DataTablesComponent as bookingComp } from './views/booking/data-tables.component';
import { BasicFormsComponent as bookingDetailComp } from './views/booking/bookingDetails/basic-forms.component';
import { DataTablesComponent as classComp } from './views/class/data-tables.component';
import { BasicFormsComponent as classDetailComp } from './views/class/classDetails/basic-forms.component';
import { DataTablesComponent as customerComp } from './views/customer/data-tables.component';
import { BasicFormsComponent as customerDetailComp } from './views/customer/customerDetails/basic-forms.component';
import { FullCalendarNgComponent as calendarComp } from './views/calendar/data-tables.component';
import { FullCalendarNgComponent as calendarHistoryComp } from './views/calendarHistory/data-tables.component';
import { DataTablesComponent as facilityAddonComp } from './views/facilityAddon/data-tables.component';
import { BasicFormsComponent as facilityAddonDetailsComp } from './views/facilityAddon/facilityAddonDetails/basic-forms.component';
import { DataTablesComponent as ownerComp } from './views/owner/data-tables.component';
import { BasicFormsComponent as ownerDetailsComp } from './views/owner/ownerDetails/basic-forms.component';
import { DataTablesComponent as courtComp } from './views/court/data-tables.component';
import { BasicFormsComponent as courtDetailsComp } from './views/court/courtDetails/basic-forms.component';
import { DataTablesComponent as paymentComp } from './views/payment/data-tables.component';
import { BasicFormsComponent as paymentDetailsComp } from './views/payment/paymentDetails/basic-forms.component';
import { ChangePasswordComponent as changePasswordComp } from './views/change-password/change-password.component';
import { DataTablesComponent as offerComp } from './views/offers/data-tables.component';
import { BasicFormsComponent as offerDetailsComp } from './views/offers/offerDetails/basic-forms.component';
import { DataTablesComponent as disabledComp } from './views/disabled/data-tables.component';
import { BasicFormsComponent as disabledDetailsComp } from './views/disabled/disabledDetails/basic-forms.component';
import { FacilityListComponent } from './views/facilityList/facilityList.component';
import { DataTablesComponent as promotionComp } from './views/promotion/data-tables.component';
import { BasicFormsComponent as promotionDetailsComp } from './views/promotion/promotionDetails/basic-forms.component';
import { DataTablesComponent as promotionConfigComp } from './views/promotionConfiguration/data-tables.component';
import { BasicFormsComponent as promotionConfigDetailsComp } from './views/promotionConfiguration/promotionConfigurationDetails/basic-forms.component';
import { DataTablesComponent as promotionAdminComp } from './views/promotionAdmin/data-tables.component';
import { BasicFormsComponent as promotionAdminDetailsComp } from './views/promotionAdmin/promotionAdminDetails/basic-forms.component';
import { DataTablesComponent as userComp } from './views/user/data-tables.component';
import { BasicFormsComponent as userDetailsComp } from './views/user/userDetails/basic-forms.component';
import { DataTablesComponent as invistigationComp } from './views/invistigation/data-tables.component';
import { BasicFormsComponent as invistigationDetailsComp } from './views/invistigation/invistigationDetails/basic-forms.component';
import { DataTablesComponent as facilityComp } from './views/facility/data-tables.component';
import { BasicFormsComponent as facilityDetailsComp } from './views/facility/facilityDetails/basic-forms.component';
import { DataTablesComponent as facilityPaymentMethodComp } from './views/facilityPaymentMethod/data-tables.component';
import { BasicFormsComponent as facilityPaymentMethodDetailsComp } from './views/facilityPaymentMethod/facilityPaymentMethodDetails/basic-forms.component';
import { DataTablesComponent as facilityScheduleComp } from './views/facilitySchedule/data-tables.component';
import { BasicFormsComponent as facilityScheduleDetailsComp } from './views/facilitySchedule/facilityScheduleDetails/basic-forms.component';
import { DataTablesComponent as facilityTimingComp } from './views/facilityTiming/data-tables.component';
import { BasicFormsComponent as facilityTimingDetailsComp } from './views/facilityTiming/facilityTimingDetails/basic-forms.component';
import { DataTablesComponent as facilityEventComp } from './views/facilityEvent/data-tables.component';
import { BasicFormsComponent as facilityEventDetailsComp } from './views/facilityEvent/facilityEventDetails/basic-forms.component';
import { DataTablesComponent as facilityImagesComp } from './views/facilityImages/data-tables.component';
import { BasicFormsComponent as facilityImagesDetailsComp } from './views/facilityImages/facilityImagesDetails/basic-forms.component';
import { DataTablesComponent as bookingReoccurComp } from './views/bookingReoccur/data-tables.component';
import { BasicFormsComponent as bookingReoccurDetailsComp } from './views/bookingReoccur/bookingReoccurDetails/basic-forms.component';
import { DataTablesComponent as membershipComp } from './views/membership/data-tables.component';
import { BasicFormsComponent as membershipDetailsComp } from './views/membership/membershipDetails/basic-forms.component';
import { DataTablesComponent as membershipConfigurationComp } from './views/membershipConfiguration/data-tables.component';
import { BasicFormsComponent as membershipConfigurationDetailsComp } from './views/membershipConfiguration/membershipConfigurationDetails/basic-forms.component';
import { DataTablesComponent as tapFacilityFileComp } from './views/tapFacilityFile/data-tables.component';
import { BasicFormsComponent as tapFacilityFileDetailsComp } from './views/tapFacilityFile/tapFacilityFileDetails/basic-forms.component';
import { DataTablesComponent as tapFacilityOnboardingComp } from './views/tapFacilityOnboarding/data-tables.component';
import { BasicFormsComponent as tapFacilityOnboardingDetailsComp } from './views/tapFacilityOnboarding/tapFacilityOnboardingDetails/basic-forms.component';
import { DataTablesComponent as coachComp } from './views/coach/data-tables.component';
import { BasicFormsComponent as coachDetailsComp } from './views/coach/coachDetails/basic-forms.component';
import { DataTablesComponent as coachPackageComp } from './views/coachPackage/data-tables.component';
import { BasicFormsComponent as coachPackageDetailsComp } from './views/coachPackage/coachPackageDetails/basic-forms.component';
import { DataTablesComponent as coachPriceComp } from './views/coachPrice/data-tables.component';
import { BasicFormsComponent as coachPriceDetailsComp } from './views/coachPrice/coachPriceDetails/basic-forms.component';
import { DataTablesComponent as bookingCategoryComp } from './views/bookingCategory/data-tables.component';
import { BasicFormsComponent as bookingCategoryDetailsComp } from './views/bookingCategory/bookingCategoryDetails/basic-forms.component';
import { DataTablesComponent as userFacilityComp } from './views/userFacility/data-tables.component';
import { BasicFormsComponent as userFacilityDetailsComp } from './views/userFacility/userFacilityDetails/basic-forms.component';
import { DataTablesComponent as coachDisabledComp } from './views/coachDisabled/data-tables.component';
import { BasicFormsComponent as coachDisabledDetailsComp } from './views/coachDisabled/coachDisabledDetails/basic-forms.component';
import { DataTablesComponent as coachPaymentMethodComp } from './views/coachPaymentMethod/data-tables.component';
import { BasicFormsComponent as coachPaymentMethodDetailsComp } from './views/coachPaymentMethod/facilityPaymentMethodDetails/basic-forms.component';
import { NewReportsComponent } from "./views/new-reports/new-reports.component";
import { TournamentComponent } from './views/tournament/tournament.component';
import { TournamentHistoryComponent } from './views/tournamentHistory/tournament.component';
import { TournamentLayoutComponent } from './views/tournamentDetails/tournament-layout/tournament-layout.component';
import { TournamentInfoComponent } from './views/tournamentDetails/tournament-info/tournament-info.component';
import { TournamentMatchesComponent } from './views/tournamentDetails/tournament-matches/tournament-matches.component';
import { TournamentEditablePageComponent } from './views/tournamentDetails/tournament-editable-page/tournament-editable-page.component';
import { CreateTournamentFormComponent } from './views/tournamentDetails/create-tournament-form/create-tournament-form.component';
import { StandingCreationComponent } from './views/tournamentDetails/standing-creation/standing-creation.component';
import { NotificationsComponent } from './views/notifications/notifications.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { SampleComponent } from './views/sample/sample.component';
import { TutorialsComponent } from './views/tutorials/tutorials.component';
import { TutorialDetailComponent } from './views/tutorials/tutorial-detail/tutorial-detail.component';
export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },

  {
    path: 'sample', component: SampleComponent,
  },

  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'login/:token',
    component: LoginComponent,
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'facilityList',
    component: FacilityListComponent,
    data: {
      title: 'Facility List',
    },
  },
  {
    path: 'change-password',
    component: changePasswordComp,
    data: {
      title: 'Change Password',
    },
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page',
    },
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: 'Dashboard',
        },
      },
      {
        path: 'calendar',
        component: calendarComp,
        data: {
          title: 'Calendar',
        },
      },
      {
        path: 'calendarHistory',
        component: calendarHistoryComp,
        data: {
          title: 'Calendar History',
        },
      },
      {
        path: 'booking',
        component: bookingComp,
        data: {
          title: 'Bookings',
        },
      },
      {
        path: 'booking/details/:id',
        component: bookingDetailComp,
        data: {
          title: 'Booking Details',
        },
      },
      {
        path: 'booking/details',
        component: bookingDetailComp,
        data: {
          title: 'Booking Details',
        },
      },

      {
        path: 'report',
        component: NewReportsComponent,
        data: {
          title: 'Reports',
        },
      },

      {
        path: 'tournaments',
        component: TournamentComponent,
        data: {
          title: 'Tournaments'
        },
      },
      

      {
        path: 'tournaments/details/:id',
        component: TournamentLayoutComponent,
        data: {
          title: 'Tournament Details'
        },
        children: [
          {
            path: '',
            redirectTo: 'info',
            pathMatch: 'full',
          },
          {
            path: 'info',
            component: TournamentInfoComponent,
            data: {
              title: 'Tournament Info'
            },
          },

          {
            path: 'matches',
            component: TournamentMatchesComponent,
            data: {
              title: 'Tournament Matches'
            },
          },
        ]
      },

      {
        path: 'tournaments/creation',
        component: CreateTournamentFormComponent,
        data: {
          title: 'Tournament Creation',
        },
      },

      {
        path: 'tournaments/editableDetails/:id',
        component: TournamentEditablePageComponent,
        data: {
          title: 'Tournament Details'
        },

      },
      {
        path: 'tournaments/standingCreation/:id',
        component: StandingCreationComponent,
        data: {
          title: 'Tournament Info'
        },
      },
      {
        path: 'tournamentsHistory',
        component: TournamentHistoryComponent,
        data: {
          title: 'Tournaments'
        },
      },
      {
        path: 'tournamentsHistory/details/:id',
        component: TournamentLayoutComponent,
        data: {
          title: 'Tournament Details'
        },
        children: [
          {
            path: '',
            redirectTo: 'info',
            pathMatch: 'full',
          },
          {
            path: 'info',
            component: TournamentInfoComponent,
            data: {
              title: 'Tournament Info'
            },
          },

          {
            path: 'matches',
            component: TournamentMatchesComponent,
            data: {
              title: 'Tournament Matches'
            },
          },
        ]
      },
      {
        path: 'tournamentsHistory/creation',
        component: CreateTournamentFormComponent,
        data: {
          title: 'Tournament Creation',
        },
      },

      {
        path: 'tournamentsHistory/editableDetails/:id',
        component: TournamentEditablePageComponent,
        data: {
          title: 'Tournament Details'
        },

      },
      {
        path: 'tournamentsHistory/standingCreation/:id',
        component: StandingCreationComponent,
        data: {
          title: 'Tournament Info'
        },
      },
      {
        path: 'booking/details',
        component: bookingDetailComp,
        data: {
          title: 'Booking Details'
        },
      },
      {
        path: 'class',
        component: classComp,
        data: {
          title: 'Class',
        },
      },
      {
        path: 'class/details',
        component: classDetailComp,
        data: {
          title: 'Class Details',
        },
      },
      {
        path: 'class/details/:id',
        component: classDetailComp,
        data: {
          title: 'Class Details',
        },
      },
      {
        path: 'facilityAddon',
        component: facilityAddonComp,
        data: {
          title: 'Addon',
        },
      },
      {
        path: 'facilityAddon/details',
        component: facilityAddonDetailsComp,
        data: {
          title: 'Addon Details',
        },
      },
      {
        path: 'facilityImages',
        component: facilityImagesComp,
        data: {
          title: 'Facility Images',
        },
      },
      {
        path: 'facilityImages/details',
        component: facilityImagesDetailsComp,
        data: {
          title: 'Images Details',
        },
      },
      {
        path: 'tutorials',
        component: TutorialsComponent,
        data: {
          title: 'Tutorials',
        },
      },
      {
        path: 'tutorials/detail',
        component: TutorialDetailComponent,
        data: {
          title: 'Tutorial Detail',
        },
      },
      {
        path: 'facilityEvent',
        component: facilityEventComp,
        data: {
          title: 'Event',
        },
      },
      {
        path: 'facilityEvent/details',
        component: facilityEventDetailsComp,
        data: {
          title: 'Event Details',
        },
      },
      {
        path: 'customer',
        component: customerComp,
        data: {
          title: 'Customers',
        },
      },
      {
        path: 'customer/details',
        component: customerDetailComp,
        data: {
          title: 'Customer Details',
        },
      },
      {
        path: 'owner',
        component: ownerComp,
        data: {
          title: 'Owners',
        },
      },
      {
        path: 'owner/details',
        component: ownerDetailsComp,
        data: {
          title: 'Owner Details',
        },
      },
      {
        path: 'court',
        component: courtComp,
        data: {
          title: 'Courts',
        },
      },
      {
        path: 'court/details',
        component: courtDetailsComp,
        data: {
          title: 'Court Details',
        },
      },
      {
        path: 'offer',
        component: offerComp,
        data: {
          title: 'Offers',
        },
      },
      {
        path: 'offer/details',
        component: offerDetailsComp,
        data: {
          title: 'Offer Details',
        },
      },
      {
        path: 'invistigation',
        component: invistigationComp,
        data: {
          title: 'Invistigations',
        },
      },
      {
        path: 'invistigation/details',
        component: invistigationDetailsComp,
        data: {
          title: 'Invistigation Details',
        },
      },
      {
        path: 'disabled',
        component: disabledComp,
        data: {
          title: 'Disabled',
        },
      },
      {
        path: 'disabled/details',
        component: disabledDetailsComp,
        data: {
          title: 'Disabled Details',
        },
      },
      {
        path: 'bookingReoccur',
        component: bookingReoccurComp,
        data: {
          title: 'Recurrant Booking',
        },
      },
      {
        path: 'bookingReoccur/details',
        component: bookingReoccurDetailsComp,
        data: {
          title: 'Recurrant Booking Details',
        },
      },
      {
        path: 'bookingCategory',
        component: bookingCategoryComp,
        data: {
          title: 'Booking Category',
        },
      },
      {
        path: 'bookingCategory/details',
        component: bookingCategoryDetailsComp,
        data: {
          title: 'Booking Category Details',
        },
      },
      {
        path: 'payment',
        component: paymentComp,
        data: {
          title: 'Payments',
        },
      },
      {
        path: 'payment/details',
        component: paymentDetailsComp,
        data: {
          title: 'Payment Details',
        },
      },
      {
        path: 'promotion',
        component: promotionComp,
        data: {
          title: 'Promotion',
        },
      },
      {
        path: 'promotion/details',
        component: promotionDetailsComp,
        data: {
          title: 'Promotion Details',
        },
      },
      {
        path: 'promotionConfiguration',
        component: promotionConfigComp,
        data: {
          title: 'Promotion Configuration',
        },
      },
      {
        path: 'promotionConfiguration/details',
        component: promotionConfigDetailsComp,
        data: {
          title: 'Promotion Configuration Details',
        },
      },
      {
        path: 'promotionAdmin',
        component: promotionAdminComp,
        data: {
          title: 'Promotion Admin',
        },
      },
      {
        path: 'promotionAdmin/details',
        component: promotionAdminDetailsComp,
        data: {
          title: 'Promotion Admin Details',
        },
      },
      {
        path: 'user',
        component: userComp,
        data: {
          title: 'Users',
        },
      },
      {
        path: 'user/details',
        component: userDetailsComp,
        data: {
          title: 'User Details',
        },
      },
      {
        path: 'facility',
        component: facilityComp,
        data: {
          title: 'Facilities',
        },
      },
      {
        path: 'facility/details',
        component: facilityDetailsComp,
        data: {
          title: 'Facility Details',
        },
      },
      {
        path: 'facilityPaymentMethod',
        component: facilityPaymentMethodComp,
        data: {
          title: 'Facility Payment Methods',
        },
      },
      {
        path: 'facilityPaymentMethod/details',
        component: facilityPaymentMethodDetailsComp,
        data: {
          title: 'Facility Payment Methods Details',
        },
      },
      {
        path: 'facilitySchedule',
        component: facilityScheduleComp,
        data: {
          title: 'Facility Schedule',
        },
      },
      {
        path: 'facilitySchedule/details',
        component: facilityScheduleDetailsComp,
        data: {
          title: 'Facility Schedule Details',
        },
      },
      {
        path: 'facilityTiming',
        component: facilityTimingComp,
        data: {
          title: 'Facility Timing',
        },
      },
      {
        path: 'facilityTiming/details',
        component: facilityTimingDetailsComp,
        data: {
          title: 'Facility Timing Details',
        },
      },
      {
        path: 'membership',
        component: membershipComp,
        data: {
          title: 'Membership',
        },
      },
      {
        path: 'membership/details',
        component: membershipDetailsComp,
        data: {
          title: 'Membership Details',
        },
      },
      {
        path: 'membershipConfiguration',
        component: membershipConfigurationComp,
        data: {
          title: 'Membership Configuration',
        },
      },
      {
        path: 'membershipConfiguration/details',
        component: membershipConfigurationDetailsComp,
        data: {
          title: 'Membership Configuration Details',
        },
      },
      {
        path: 'tapFacilityFile',
        component: tapFacilityFileComp,
        data: {
          title: 'Tap Facility File',
        },
      },
      {
        path: 'tapFacilityFile/details',
        component: tapFacilityFileDetailsComp,
        data: {
          title: 'Tap Facility File Details',
        },
      },
      {
        path: 'tapFacilityOnboarding',
        component: tapFacilityOnboardingComp,
        data: {
          title: 'Tap Facility Onboarding',
        },
      },
      {
        path: 'tapFacilityOnboarding/details',
        component: tapFacilityOnboardingDetailsComp,
        data: {
          title: 'Tap Facility Onboarding Details',
        },
      },
      {
        path: 'userFacility',
        component: userFacilityComp,
        data: {
          title: 'User',
        },
      },
      {
        path: 'userFacility/details',
        component: userFacilityDetailsComp,
        data: {
          title: 'User Details',
        },
      },
      {
        path: 'coach',
        component: coachComp,
        data: {
          title: 'Coach',
        },
      },
      {
        path: 'coach/details',
        component: coachDetailsComp,
        data: {
          title: 'Coach Details',
        },
      },
      {
        path: 'coachPackage',
        component: coachPackageComp,
        data: {
          title: 'Coach Package',
        },
      },
      {
        path: 'coachPackage/details',
        component: coachPackageDetailsComp,
        data: {
          title: 'Coach Package Details',
        },
      },
      {
        path: 'coachPrice',
        component: coachPriceComp,
        data: {
          title: 'Coach Price',
        },
      },
      {
        path: 'coachPrice/details',

        component: coachPriceDetailsComp,
        data: {
          title: 'Coach Price Details',
        },
      },
      {
        path: 'coachDisabled',
        component: coachDisabledComp,
        data: {
          title: 'Coach Disabled',
        },
      },
      {
        path: 'coachDisabled/details',
        component: coachDisabledDetailsComp,
        data: {
          title: 'Coach Disabled Details',
        },
      },

      {
        path: 'coachPaymentMethod',
        component: coachPaymentMethodComp,
        data: {
          title: 'Coach Payment Methods',
        },
      },
      {
        path: 'coachPaymentMethod/details',
        component: coachPaymentMethodDetailsComp,
        data: {
          title: 'Coach Payment Methods Details',
        },
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        data: {
          title: 'Notification',
        },
      },

      {
        path: 'apps/email',
        component: EmailLayoutComponent,

        children: [
          {
            path: '',
            loadChildren: () =>
              import('./views/components/apps/email/email.module').then((m) => m.EmailModule),
          },
        ],
      },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/components/theme/theme.module').then((m) => m.ThemeModule),
      },
      {
        path: 'base',
        loadChildren: () =>
          import('./views/components/base/base.module').then((m) => m.BaseModule),
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/components/buttons/buttons.module').then((m) => m.ButtonsModule),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/components/chartjs/chartjs.module').then((m) => m.ChartjsModule),
      },
      {
        path: 'editors',
        loadChildren: () =>
          import('./views/components/editors/editors.module').then((m) => m.EditorsModule),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/components/forms/forms.module').then((m) => m.FormsModule),
      },
      {
        path: 'google-maps',
        loadChildren: () =>
          import('./views/components/maps/maps.module').then((m) => m.MapsModule),
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/components/icons/icons.module').then((m) => m.IconsModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/components/notifications/notifications.module').then(
            (m) => m.NotificationsModule
          ),
      },
      {
        path: 'plugins',
        loadChildren: () =>
          import('./views/components/plugins/plugins.module').then((m) => m.PluginsModule),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/widgets.module').then((m) => m.WidgetsModule),
      },
      {
        path: 'apps',
        loadChildren: () =>
          import('./views/components/apps/apps.module').then((m) => m.AppsModule),
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
